import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { showToast } from './Toast';

// PRD-008 F6 / AC-1 — gates /internal/* to users with
// is_platform_operator = true. Non-operators are redirected to
// /dashboard with a toast explaining why.
export default function PlatformOperatorRoute({ children }) {
  const { user, loading, isAuthenticated } = useAuth();
  const isOperator = user?.is_platform_operator === true;
  const denied = !loading && isAuthenticated && !isOperator;

  useEffect(() => {
    if (denied) {
      showToast({
        headline: 'Operator-only area',
        body: 'This page is restricted to Verdict platform operators.',
      });
    }
  }, [denied]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isOperator) return <Navigate to="/dashboard" replace />;
  return children;
}
